export const date_format = 'YYYY-MM-DD';
export const date_time_format = 'YYYY-MM-DD HH:mm';



// WEBPACK FOOTER //
// ./src/js/utils/constants.js